import { render } from "./Auth.vue?vue&type=template&id=a556fa0e&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"

import "./Auth.vue?vue&type=style&index=0&id=a556fa0e&lang=css"
import "./Auth.vue?vue&type=style&index=1&id=a556fa0e&scoped=true&lang=css"

import exportComponent from "/builds/off-group-apps/personal-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a556fa0e"]])

export default __exports__